<template>

  <div>
    <el-submenu :index="resolvePath(item.path)" v-if="item.children && item.children.length > 0">
      <template slot="title">
        <router-link :to="resolvePath(item.path)">
          <!--<i class="el-icon-location"></i>-->
          <svg-icon v-if="item.note" :icon-class="item.note"></svg-icon>
          <span>{{ item.name }}</span>
        </router-link>
      </template>
      <siderbar-item v-for="child in item.children" :item="child" :base-path="resolvePath(item.path)" :key="child.code"></siderbar-item>
    </el-submenu>
    <el-menu-item  v-else :index="resolvePath(item.path)">
      <template slot="title">
        <!--<i class="el-icon-location"></i>-->
        <svg-icon v-if="item.note" :icon-class="item.note"></svg-icon>
        <span v-else style="width: 1em; height: 1em">&#12288;</span>
        <span>{{ item.name }}</span>
      </template>
    </el-menu-item>
  </div>
</template>

<script>
  import path from 'path'
  export default {
    name: 'siderbarItem',
    props: {
      // route配置json
      item: {
        type: Object,
        required: true
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    methods: {
      resolvePath: function(...paths) {
        return path.resolve(this.basePath, ...paths)
      }
    }
  }
</script>

<style scoped>
  .svg-icon {
    margin-right: 5px;
    color: #d5d9da;
    font-size: 1.3em;
  }
</style>

<style>
  .el-submenu .el-menu-item {
    min-width: 9vw;
    padding-left: 40px !important;
  }
  .el-submenu__title {
    padding-left: 20px !important;
  }
</style>